<script>
  import { Button } from 'flowbite-svelte';
  import { USER_TYPE } from './constants';
  import { queryUserData } from './data/userData';
  import { _ } from 'svelte-i18n';

  const userQuery = queryUserData();

  $: isUserUnmanaged =
    $userQuery.data?.object?.userType === USER_TYPE.UNMANAGED;
  $: email = isUserUnmanaged
    ? 'buttoncreatorsupport@usebutton.com'
    : 'amazonsupport@usebutton.com';
</script>

<div class="w-full rounded-md bg-slate-100 p-2">
  <h4 class="text-md font-bold">
    {$_('SideNavFeedback.header', { default: 'Have Feedback?' })}
  </h4>
  <p class="mt-1 text-sm">
    {$_('SideNavFeedback.body', {
      default: "We'd love to hear it.",
    })}
  </p>
  {#if $userQuery.isSuccess}
    <Button
      size="sm"
      class="mt-2 bg-black hover:bg-gray-700"
      href={`mailto:${email}`}
    >
      {$_('SideNavFeedback.cta.emailUs', {
        default: 'Email Us',
      })}
    </Button>
  {/if}
</div>
